import mashLogo from "@/assets/logo.png";
import loginArtifact from "@/pages/Login/assets/login-artifact.svg";

export function AuthDesktopLeftPane() {
  return (
    <div className="hidden shrink-0 flex-col items-center justify-center border-r border-[#E8EAEF] bg-white md:flex md:w-[52%] md:px-8 md:py-10 lg:w-[57.64%] lg:px-10 lg:py-12 xl:px-12 xl:py-12 2xl:px-20 2xl:py-20">
      <div className="flex w-full max-w-[24rem] flex-col items-center lg:max-w-[26rem] xl:max-w-[30rem] 2xl:max-w-[36rem]">
        <div className="text-center">
          <p className="text-[1.625rem] leading-[1.1] font-bold tracking-tight text-[#1f2430] md:text-[1.75rem] lg:text-[2rem] lg:leading-tight xl:text-[2.25rem] 2xl:text-[2.75rem] 2xl:leading-none">
            Welcome to
          </p>
          <img
            src={mashLogo}
            alt="Mash"
            className="mx-auto mt-3 h-auto w-full max-w-[12rem] object-contain md:mt-4 md:max-w-[14rem] lg:mt-4 lg:max-w-[16rem] xl:max-w-[17.5rem] 2xl:mt-6 2xl:max-w-[19.5rem]"
          />
        </div>

        <div className="mt-6 w-full md:mt-7 lg:mt-8 xl:mt-10 2xl:mt-14">
          <img
            src={loginArtifact}
            alt=""
            className="mx-auto h-auto w-full max-w-[20rem] object-contain md:max-w-[22rem] lg:max-w-[24rem] xl:max-w-[28rem] 2xl:max-w-[34rem]"
          />
        </div>
      </div>
    </div>
  );
}
